// src/pages/PersonalProfile.js
import React, { useState } from "react";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/PersonalIDs.css";
import "../assets/styles/Ratings.css";
import "../assets/styles/CRMOpenLead.css";

import like from "../assets/img/like.svg";
import dislike from "../assets/img/dislike.svg";
import normallike from "../assets/img/normallike.svg";
import normaldislike from "../assets/img/normaldislike.svg";
import togglelike from "../assets/img/togglelike.svg";
import toggledislike from "../assets/img/toggledislike.svg";


import pencil from "../assets/img/pencil.svg";
import personalleft from "../assets/img/personal-left.svg";
import leadleft from "../assets/img/lead-left.svg";

import filter1 from '../assets/img/filter1.png'
import { FaStar, FaMapMarkerAlt, FaPen ,FaChevronRight,} from "react-icons/fa";
import { FaTimes } from "react-icons/fa"; // import this at the top

// import userImg from "../assets/img/user.svg";
// import star from "../assets/img/star.svg";

export default function PersonalProfile() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    refraId: "MH/A/12345/2020",
    aadhaar: "XXXX XXXX 4567",
    pan: "ABCDE1234F",
    gst: "27AADCB2230M1ZT",
    tan: "MUMB12345A",
  });
  const [filter, setFilter] = useState("all");
    const [showModal, setShowModal] = useState(false);
    const [reviewText, setReviewText] = useState("");
    const [likeStatus, setLikeStatus] = useState(null);
    const [formData1, setFormData1] = useState({
          firstName: "Rajesh",
          lastName: "Sharma",
          email: "rajesh.sharma@gmail.com",
          phone: "+91 98765 43210",
          address: "Road no.2, Banjara Hills, Shangrila Plaza, opp KBR Park.",
          pincode: "500034",
          city: "Hyderabad",
          state: "Telangana",
        });
    
  
    const reviews = [
      {
        id: 1,
        name: "Neha Sharma",
        date: "May 12, 2025",
        text: "Rajesh and his team were incredibly helpful throughout our property search. They understood our requirements perfectly and showed us properties that matched our needs. The transaction was smooth and hassle-free.",
        liked: true,
      },
      {
        id: 2,
        name: "Amit Verma",
        date: "May 14, 2025",
        text: "Professional and responsive! Rajesh's team made the buying process easy and transparent.",
        liked: true,
      },
      {
        id: 3,
        name: "Priya Nair",
        date: "May 20, 2025",
        text: "Not satisfied with the options shown. They didn’t match my budget expectations.",
        liked: false,
      },
      {
        id: 4,
        name: "Karan Mehta",
        date: "May 22, 2025",
        text: "Rajesh helped us close our dream apartment. Highly recommended for first-time buyers!",
        liked: true,
      },
    ];
  
    const totalLikes = reviews.filter((r) => r.liked).length;
    const totalDislikes = reviews.length - totalLikes;
    const total = reviews.length;
    const likePercent = (totalLikes / total) * 100;
    const dislikePercent = (totalDislikes / total) * 100;
  
    const filteredReviews =
      filter === "all"
        ? reviews
        : filter === "liked"
        ? reviews.filter((r) => r.liked)
        : reviews.filter((r) => !r.liked);
  
    const handleFilterClick = (type) => {
      setFilter((prev) => (prev === type ? "all" : type));
    };
  
    const handleSubmitReview = () => {
      console.log({
        liked: likeStatus === "like",
        text: reviewText,
      });
      setShowModal(false);
      setReviewText("");
      setLikeStatus(null);
    };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? "" : section);
  };
   const [show, setShow] = useState(false);
    const [openIndex, setOpenIndex] = useState(0);
   
    const [activeTab, setActiveTab] = useState("Leads");
     const [selected, setSelected] = useState("5 Star");
   const ratings = ["5 Star", "4 Star", "3 Star", "2 Star", "1 Star"];
  
    const toggleInvoice = (i) => {
      setOpenIndex(openIndex === i ? null : i);
    };

  return (
    <div className="d-flex" style={{ background: "#fff", minHeight: "100vh" }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />

        {/* Accordion Container */}
        <div className=" p-3">

         

          {/* SECTION 2: Personal Information */}
          <div className="accordion-item mb-3">
            <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("personalinformation")}
            >
              <h6 className="accordion-title mb-0">Personal Information</h6>
              <span className={`accordion-arrow ${activeSection === "personalinformation" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "personalinformation" && (
              <div className="accordion-body">
                  <div className="card p-4 personal-ids-card">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="personal-head mb-0">
                 
                  Personal Information
                </h6>
 
                {!isEditing ? (
                  <button
                    className="border-0"
                    style={{ background: "none" }}
                    onClick={() => setIsEditing(true)}
                  >
                    <img src={pencil} width={20} height={20} alt="edit" />
                  </button>
                ) : (
                  <></>
                )}
              </div>
 
              {/* Form */}
              <div className="form-group mb-3">
                <label className="form-label personal-label">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control personal-input"
                  value={formData1.firstName}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control personal-input"
                  value={formData1.lastName}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Email ID</label>
                <input
                  type="email"
                  name="email"
                  className="form-control personal-input"
                  value={formData1.email}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control personal-input"
                  value={formData1.phone}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Address</label>
                <textarea
                  name="address"
                  className="form-control personal-input"
                  rows="2"
                  value={formData1.address}
                  onChange={handleChange}
                  readOnly={!isEditing}
                ></textarea>
              </div>
 
              <div className="row">
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    className="form-control personal-input"
                    value={formData1.pincode}
                    onChange={handleChange}
                    readOnly={!isEditing}
                  />
                </div>
 
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control personal-input"
                    value={formData1.city}
                    onChange={handleChange}
                    readOnly={!isEditing}
                  />
                </div>
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">State</label>
                <input
                  type="text"
                  name="state"
                  className="form-control personal-input"
                  value={formData1.state}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>
 
              {/* Save Button in edit mode */}
              {isEditing && (
                <div className="d-flex justify-content-end">
                  <button
                    className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                    onClick={() => setIsEditing(false)}
                    style={{ minWidth: "120px" }}
                  >
                    <span className="personal-uspbtntext">Save</span>
                  </button>
                </div>
              )}
            </div>
              </div>
            )}
          </div>

           {/* SECTION 1: Personal IDs */}
          <div className="accordion-item mb-3">
           <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("personalids")}
            >
              <h6 className="accordion-title mb-0">Personal IDs</h6>
              <span className={`accordion-arrow ${activeSection === "personalids" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "personalids" && (
              <div className="accordion-body ">
                <div className="card p-4 personal-ids-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6 className="personal-head mb-0">
                      
                      Personal IDs
                    </h6>
                    {!isEditing && (
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => setIsEditing(true)}
                      >
                        <img src={pencil} width={20} height={20} alt="edit" />
                      </button>
                    )}
                  </div>

                  {/* Form */}
                  <div className="form-group mb-3">
                    <label className="form-label personal-label mb-2">
                      REFRA IDs
                    </label>
                    <input
                      type="text"
                      name="refraId"
                      className="form-control personal-input"
                      value={formData.refraId}
                      onChange={handleChange}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">Aadhaar</label>
                    <input
                      type="text"
                      name="aadhaar"
                      className="form-control personal-input"
                      value={formData.aadhaar}
                      onChange={handleChange}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">PAN</label>
                    <input
                      type="text"
                      name="pan"
                      className="form-control personal-input"
                      value={formData.pan}
                      onChange={handleChange}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">GST</label>
                    <input
                      type="text"
                      name="gst"
                      className="form-control personal-input"
                      value={formData.gst}
                      onChange={handleChange}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">TAN</label>
                    <input
                      type="text"
                      name="tan"
                      className="form-control personal-input"
                      value={formData.tan}
                      onChange={handleChange}
                      readOnly={!isEditing}
                    />
                  </div>

                  {isEditing && (
                    <div className="d-flex justify-content-end">
                      <button
                        className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                        onClick={() => setIsEditing(false)}
                        style={{ minWidth: "120px" }}
                      >
                        <span className="personal-uspbtntext">Save</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* SECTION 3: Ratings & Reviews */}
          <div className="accordion-item mb-3">
            <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("ratingsreviews")}
            >
              <h6 className="accordion-title mb-0">Ratings & Reviews</h6>
              <span className={`accordion-arrow ${activeSection === "ratingsreviews" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "ratingsreviews" && (
              <div className="accordion-body">
               <div >
          <div className="crm-openlead-container p-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="ratings-title">
               
                Reviews
              </h5>
            </div>

            {/* Like / Dislike Toggles */}
            <div className="review-summary">
              <div className="toggle-row mb-3">
                <div className="toggle-group">
                  {/* Like Toggle */}
                  <div
                    className={`switch-toggle ${
                      filter === "liked" ? "on-like" : ""
                    }`}
                    onClick={() => handleFilterClick("liked")}
                  >
                    <div className="switch-track px-2"></div>
                    <div className="switch-thumb">
                      <img src={togglelike} alt="like" />
                    </div>
                    <span className="switch-count">{totalLikes}</span>
                  </div>

                  {/* Dislike Toggle */}
                  <div
                    className={`switch-toggle ${
                      filter === "disliked" ? "on-dislike" : ""
                    }`}
                    onClick={() => handleFilterClick("disliked")}
                  >
                    <div className="switch-track"></div>
                    <div className="switch-thumb">
                      <img src={toggledislike} alt="dislike" />
                    </div>
                    <span className="switch-count">{totalDislikes}</span>
                  </div>
                </div>

                {/* Add Review Button */}
                {/* <button
                  className="add-review-btn"
                  onClick={() => setShowModal(true)}
                >
                  Add Reviews
                </button> */}
              </div>

              {/* Progress Bar */}
              <div className="progress-bar-container mb-4">
                <div
                  className="progress-like"
                  style={{ width: `${likePercent}%` }}
                ></div>
                <div
                  className="progress-dislike"
                  style={{ width: `${dislikePercent}%` }}
                ></div>
              </div>
            </div>

            {/* Reviews List */}
            {filteredReviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-header">
                  <div className="reviewer-info">
                    <img
                      src={`https://randomuser.me/api/portraits/${
                        review.liked ? "women" : "men"
                      }/${review.id * 10}.jpg`}
                      alt={review.name}
                      className="review-avatar"
                    />
                    <span className="reviewer-name">{review.name}</span>
                  </div>

                  <img
                    src={review.liked ? like : dislike}
                    alt="like/dislike"
                    className="review-thumb-right"
                  />
                </div>

                <p className="review-text">{review.text}</p>

                <div className="review-footer">
                  <div className="review-date">{review.date}</div>
                </div>
              </div>
            ))}

            <div className="text-end">
              <button className="view-all-btn">
                <span className="view-all-btntext"> View All Reviews</span>
              </button>
            </div>
          </div>
        </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
